<template>
  <div id="page" v-cloak>
    <mescroll-vue ref="mescroll" :up="mescrollUp" @init="mescrollInit">
      <ul class="upoad_list">
        <li class="clear" v-for="item in dataList">
          <div class="info lt">
            <p></p>
            <p>订单编号：{{item.tb_order_no}}</p>
            <p>上传时间：{{item.date}}</p>
            <p style="color:#ff5555;" v-if="item.auditDesc">拒绝原因：{{item.auditDesc}}</p>
          </div>
          <div style="" class="state rt" :class="{ failure : item.status == 2 , await : item.status == 1 }">
            {{item.status==0?'待审核':item.status==1?'审核通过':'拒绝'}}
          </div>
        </li>
        <div id="warpId"></div>
      </ul>
    </mescroll-vue>
  </div>
</template>

<script>
  import '../assets/style.css'
  import MescrollVue from 'mescroll.js/mescroll.vue'
  export default {
    name: 'UploadList',
    components: {
      MescrollVue // 注册mescroll组件
    },
    data() {
      return {
        userId: '',
        H5Key: '',
        md5: '',
        initData: {},
        mescroll: null, // mescroll实例对象
        mescrollUp: { // 上拉加载的配置.
          callback: this.upCallback, // 上拉回调,此处简写; 相当于 callback: function(page, mescroll) { }
          htmlNodata: '<p class="upwarp-nodata">-- 已经到底了 --</p>',
          toTop: {
            //回到顶部按钮
            src: "http://dig-mineral.yeedian365.com/taobao_union/img/mescroll-totop.png", //图片路径,默认null,支持网络图
            offset: 1000 //列表滚动1000px才显示回到顶部按钮
          },
          empty: {
            //列表第一页无任何数据时,显示的空提示布局; 需配置warpId才显示
            warpId: "warpId", //父布局的id (1.3.5版本支持传入dom元素)
            icon: "http://dig-mineral.yeedian365.com/taobao_union/img/mescroll-empty.png", //图标,默认null,支持网络图
            tip: "暂无相关数据~" //提示
          }
        },
        dataList: [], // 列表数据
        minId: '',
      }
    },
    mounted() {
      if (window.LaiaJs) {
        window.LaiaJs.setTitle('上传记录');
        this.userId = window.LaiaJs.getUserId();
        this.H5Key = window.LaiaJs.getH5Key();
        this.md5 = this.$md5(this.H5Key);
      } else {
        this.userId = '503a84e4f4374ec5916db6086bbe7b71';
        this.H5Key = 'UpSzXt4t5tSwTD2uYqVC1vPxVA1DWAWq';
        this.md5 = this.$md5(this.H5Key);
      }
    },
    methods: {
      // mescroll组件初始化的回调,可获取到mescroll对象
      mescrollInit(mescroll) {
        this.mescroll = mescroll // 如果this.mescroll对象没有使用到,则mescrollInit可以不用配置
      },
      upCallback(page, mescroll) {
        if (page.num == 1) this.minId = "";
        //联网请求
        this.$axios.post("task/getTaobaoOrderImageList.do", {
          "user_id": this.userId,
          "sign": this.md5,
          "min_id": this.minId,
          "limit": 10,
        }).then((res) => {
          // console.log(res);
          //请求的列表数据
          var list = res.data.list;
          // console.log(list)
          if (page.num == 1) this.dataList = [];
          //把请求到的数据添加到列表
          this.dataList = this.dataList.concat(list);
          this.minId = this.dataList[0]!=undefined?this.dataList[this.dataList.length-1].tb_order_no:'';
          //数据渲染成功后,隐藏下拉刷新的状态
          this.$nextTick(() => {
            this.mescroll.endSuccess(list.length);
          })
        }).catch((e) => {
          //联网失败的回调,隐藏下拉刷新和上拉加载的状态;
          this.mescroll.endErr();
        })
      },
    }
  }
</script>


<style>
  [v-cloak] {
    display: none;
  }

  #page {
    width: 100%;
    height: 100vh;
  }

  .upoad_list li {
    padding: 0.2rem 0.3rem;
    border-bottom: 1px solid #ddd;
  }

  .upoad_list li .info {
    margin-left: 0.2rem;
  }

  .upoad_list li .info p {
    font-size: 0.34rem;
    color: #999;
  }

  .upoad_list li .state {
    color: #999;
    font-size: 0.4rem;
    line-height: 1rem;
  }

  .upoad_list li .await {
    color: #555;
    font-size: 0.4rem;
    line-height: 1rem;
  }

  .upoad_list li .failure {
    color: #ff5555;
    font-size: 0.4rem;
    line-height: 1.4rem;
  }
</style>



// WEBPACK FOOTER //
// src/pages/UploadList.vue